import React, { useContext } from 'react'
import { PostPurchaseContext, PostPurchaseDispatchContext } from '../context/PostPurchaseContext';
function FormCheckbox({ label, name, extraClasses }) {
    const state = useContext(PostPurchaseContext);
    const dispatch = useContext(PostPurchaseDispatchContext);

    return (
        <label className={`flex items-center text-[12px] ${extraClasses}`} onClick={() => dispatch({ type: 'setCustomerData', payload: { name: name, value: !state[name] } })}>
            <input name={name} value={state[name]} type="checkbox" />
            <button type="button" className={`w-[16px] h-[16px] bg-white border border-muted-400 rounded-lg mr-2 relative shrink-0 ${state[name] == true ? "after:content-['✓'] after:text-brio-400 after:absolute after: inset-0 after:-translate-x-1/2 after:-translate-y-1/2" : ""}`} />
            <div className="text-left">{label}</div>
        </label>
    )
}

export default FormCheckbox